import { SearchForTaskSubjectsItem } from "core/queries/SearchForTaskSubjects";

export const getIntrastayCleaningConfig = (
  subject?: SearchForTaskSubjectsItem | null,
) => {
  if (!subject) {
    return null;
  }

  const { resource } = subject;
  switch (resource.__typename) {
    case "Inquiry":
    case "LeaseInquiry":
      return resource.intrastayCleaningConfig;
    default:
      return null;
  }
};
